<div class="content-card w-full p-3 border-round shadow-1">
  @if (title()) {
    <header class="mb-3 text-left">
      <h1 class="m-0 text-xl font-medium text-color">{{ title() }}</h1>
    </header>
  }
  <ng-content />
</div>
